import { render } from "./TypeMaster.vue?vue&type=template&id=4455eb10&scoped=true"
import script from "./TypeMaster.vue?vue&type=script&lang=js"
export * from "./TypeMaster.vue?vue&type=script&lang=js"

import "./TypeMaster.vue?vue&type=style&index=0&id=4455eb10&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4455eb10"]])

export default __exports__